export default __webpack_public_path__ + "static/media/price.36e68de8.svg";